"use strict";

const DisplayHomes = () => {
    const init = () => {
        $(function () {
            $('.js-view-toggle').on('click', function () {
                $('.js-view-toggle').removeClass('active');
                $(this).addClass('active');
                $(this).parents('.js-map-holder').removeClass('list-view map-view');
                $(this).parents('.js-map-holder').addClass($(this).data('id')+'-view');
            })
            
        });
    };

    return {
        init: init
    };
};

export default DisplayHomes;